export const CONSOLE = {
  // nav
  connectBtn: "connect-wallet-btn",
  disconnectBtn: "disconnect-wallet-btn",
  navOverview: "nav-overview",
  navOperations: "nav-operations",
  navCompliance: "nav-compliance",
  navAccess: "nav-access",
  navAudit: "nav-audit",
  navContract: "nav-contract",
  navConfig: "nav-config",
  // overview
  totalSupplyStat: "total-supply-stat",
  maxSupplyStat: "max-supply-stat",
  statusStat: "contract-status-stat",
  proxyAddress: "proxy-address",
  implAddress: "impl-address",
  // operations
  mintAmountInput: "mint-amount-input",
  mintToInput: "mint-to-input",
  mintSubmitBtn: "mint-submit-btn",
  burnAmountInput: "burn-amount-input",
  burnFromInput: "burn-from-input",
  burnSubmitBtn: "burn-submit-btn",
  configureMinterAddr: "configure-minter-address",
  configureMinterAllowance: "configure-minter-allowance",
  configureMinterBtn: "configure-minter-btn",
  // compliance
  blacklistAddrInput: "blacklist-address-input",
  blacklistReasonInput: "blacklist-reason-input",
  blacklistSubmitBtn: "blacklist-submit-btn",
  unblacklistBtn: (a) => `unblacklist-btn-${a}`,
  pauseToggle: "pause-toggle",
  pauseConfirmBtn: "pause-confirm-btn",
  // access
  roleSelect: "role-select",
  roleAddressInput: "role-address-input",
  roleNoteInput: "role-note-input",
  roleGrantBtn: "role-grant-btn",
  roleRevokeBtn: (r, a) => `role-revoke-${r}-${a}`,
  // config
  proxyInput: "config-proxy-input",
  networkInput: "config-network-input",
  chainIdInput: "config-chainid-input",
  rpcInput: "config-rpc-input",
  explorerInput: "config-explorer-input",
  saveConfigBtn: "save-config-btn",
};
